import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import Layout from '../layout';
import PrivateContent from './PrivateContent';
import { useSelector } from 'react-redux';
import { RootState } from '../state/reducers';
const AuthorizedContent = () => {
    const { user_info } = useAuth();
    const is_must_reset_pw = user_info?.is_must_reset_pw;
    const { appConfig } = useSelector((x: RootState) => x.appConfig)
    useEffect(() => {
        if (is_must_reset_pw) {
            window.location.href = `${(appConfig?.OIDC_AUTHORITY ?? "").replace("auth", "portal")}/change-password`;
        }
    }, [is_must_reset_pw])
    return (
        <>
            <Layout>
                <PrivateContent />
            </Layout>
        </>

    );
};

export default AuthorizedContent;